import {
    Button,
    ButtonGroup,
    Col,
    Icon,
    ModalV2,
    ModalV2Content,
    ModalV2Footer,
    ModalV2Title,
    Row,
    SegmentLoader,
} from '@si-armes/dsfr-react';
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import styles from './ModaleInformationArme.module.scss';
import { displayStatut, formaterDate } from '../../../../../utils/utils';
import SectionPresentationArme from './SectionPresentationArme';
import TemplateBoutonsActions from '../components/BoutonsActions/TemplateBoutonsActions';
import BoutonFichierTelechargeable from '../../../../../components/Commun/Fichier/BoutonFichierTelechargeable';
import usagerClientReducer from '../../../../../store/usagerReducer';
import {
    API_GET_FICHE_SITUATION_ARME,
    CONTEXT_FICHE_SITUATION_ARME,
} from '../../../../../constants/apiUrls.constants';
import { FICHE_SITUATION_PDF } from '../../../../../constants/fileConstant';
import { MIME_APPLICATION_PDF } from '../../../../../utils/fileFunction';
import { getAPI } from '../../../../../store/apiReducer';
import {
    LIBELLE_EXPEDITION_EN_COURS,
    STATUT_TRANSFERT,
} from '../../../../../components/arme/statuts/StatutsArmes';

const ModaleInformationArme = ({
    getApi,
    arme,
    fermerModale,
    dataProfil,
    ouvrirModalePerteVol,
    ouvrirModaleValiderAcquisition,
    rechargerTableau,
    dataFicheSituation,
    isLoadingFicheSituation,
}) => {
    const LOCALISATION_ORIGINE = "Localisation d'origine";
    const { data: dataDeroule, isLoading: isLoadingDeroule } = useSelector(
        (state) => state.armes.recupererDeroule,
    );

    const dialog = useRef();

    useEffect(() => {
        if (dialog.current) {
            dialog.current.showModal();
        }
    }, [dialog]);

    const [contenuFicheSituation, setContenuFicheSituation] = useState('');
    const genererFicheSituation = () => {
        setContenuFicheSituation(dataFicheSituation);
    };

    const recupererDataFicheSituation = () => {
        if (arme?.uniquid) {
            getApi(
                usagerClientReducer,
                API_GET_FICHE_SITUATION_ARME + arme.uniquid,
                CONTEXT_FICHE_SITUATION_ARME,
            );
            dataDeroule.ficheSituation = {
                titreFichier: FICHE_SITUATION_PDF,
                mimeType: MIME_APPLICATION_PDF,
            };
        }
    };

    return (
        <ModalV2
            id="information-arme-modal"
            idModalTitle="information-arme-modal-title"
            size="lg"
            onClose={fermerModale}
            ref={dialog}
        >
            <ModalV2Content>
                <SegmentLoader isLoading={isLoadingDeroule || isLoadingFicheSituation} taille="sm">
                    <ModalV2Title id="information-arme-modal-title">
                        {arme.marque} modèle {arme.modele}
                    </ModalV2Title>
                    {dataDeroule && (
                        <>
                            <Row className={styles.armeDetailsContainer}>
                                <Col className="fr-pr-3w">
                                    <Row className={styles.armeDetailsTitle}>Numéro d'encodage</Row>
                                    <Row>{arme.numeroEncodage}</Row>
                                </Col>

                                <Col>
                                    <Row className={styles.armeDetailsTitle}>Classement</Row>
                                    <Row>{arme.classement}</Row>
                                </Col>

                                <Col>
                                    <Row className={styles.armeDetailsTitle}>Détention</Row>
                                    <Row>{arme.regimeDetention}</Row>
                                </Col>

                                <Col>
                                    <Row className={styles.armeDetailsTitle}>Statut</Row>
                                    <Row style={{ whiteSpace: 'nowrap' }}>
                                        {displayStatut(arme.statut)}
                                    </Row>
                                </Col>
                            </Row>

                            {!dataFicheSituation && (
                                <Button onClick={recupererDataFicheSituation}>
                                    Générer la fiche situation de l'arme
                                </Button>
                            )}
                            {dataFicheSituation && (
                                <BoutonFichierTelechargeable
                                    handleOnClick={genererFicheSituation}
                                    label="Télécharger la fiche de situation"
                                    titreFichier={dataDeroule.ficheSituation.titreFichier}
                                    mimeType={dataDeroule.ficheSituation.mimeType}
                                    contenu={contenuFicheSituation}
                                    callBack={() => setContenuFicheSituation('')}
                                />
                            )}

                            <Row className={styles.sectionTitle}>
                                <Icon icon="fr-icon-file-text-line" className={styles.icon} />
                                <p className={styles.sousSectionTitle}>Informations principales</p>
                            </Row>
                            <div className={styles.border}>
                                <Row>
                                    <Col col={3}>
                                        <Row className={styles.armeDetailsTitle}>
                                            Détenue depuis le
                                        </Row>
                                        <Row className={styles.armeDetailsInfo}>
                                            {formaterDate(dataDeroule.dateDetention)}
                                        </Row>
                                    </Col>

                                    <Col col={3}>
                                        <Row className={styles.armeDetailsTitle}>Référence RGA</Row>
                                        <Row className={styles.armeDetailsInfo}>
                                            {dataDeroule.rga.numeroRGA}
                                        </Row>
                                    </Col>

                                    <Col col={3}>
                                        <Row className={styles.armeDetailsTitle}>
                                            Classement européen
                                        </Row>
                                        <Row className={styles.armeDetailsInfo}>
                                            {dataDeroule.rga.classementEuropeen}
                                        </Row>
                                    </Col>

                                    <Col col={3}>
                                        <Row className={styles.armeDetailsTitle}>
                                            Mode de fonctionnement
                                        </Row>
                                        <Row className={styles.armeDetailsInfo}>
                                            {dataDeroule.rga.modeFonctionnement}
                                        </Row>
                                    </Col>

                                    <Col col={3}>
                                        <Row className={styles.armeDetailsTitle}>
                                            Système d'alimentation
                                        </Row>
                                        <Row className={styles.armeDetailsInfo}>
                                            {dataDeroule.rga.modeAlimentation}
                                        </Row>
                                    </Col>

                                    <Col col={3}>
                                        <Row className={styles.armeDetailsTitle}>
                                            Longueur de l'arme
                                        </Row>
                                        <Row className={styles.armeDetailsInfo}>
                                            {dataDeroule.rga.longueurArme}
                                        </Row>
                                    </Col>

                                    <Col col={3}>
                                        <Row className={styles.armeDetailsTitle}>
                                            Capacité totale
                                        </Row>
                                        <Row className={styles.armeDetailsInfo}>
                                            {dataDeroule.rga.capaciteHorsChambre} +{' '}
                                            {dataDeroule.rga.capaciteEnChambre} ={' '}
                                            {dataDeroule.rga.capaciteHorsChambre +
                                                dataDeroule.rga.capaciteEnChambre}
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                            <div className={styles.border}>
                                <Row className={styles.sectionTitle}>
                                    <Icon icon="fr-icon-file-line" className={styles.icon} />
                                    <p className={styles.sousSectionTitle}>Éléments essentiels</p>
                                </Row>

                                {[
                                    dataDeroule.rga.canonUn,
                                    dataDeroule.rga.canonDeux,
                                    dataDeroule.rga.canonTrois,
                                    dataDeroule.rga.canonQuatre,
                                ]
                                    .filter(Boolean)
                                    .map((canon, index) => (
                                        <SectionPresentationArme
                                            key={canon.id}
                                            titre={`Canon ${index + 1}`}
                                            donnees={[
                                                ['Calibre', canon.libelleCalibre],
                                                ['Mode de percussion', canon.percussion],
                                                ['Type de canon', canon.typeCanon],
                                                ['Longueur du canon', canon.longueur],
                                            ]}
                                        />
                                    ))}
                            </div>
                            <div className={styles.border}>
                                <Row className={styles.sectionTitle}>
                                    <Icon icon="fr-icon-map-pin-2-line" className={styles.icon} />
                                    <p className={styles.sousSectionTitle}>
                                        Localisation de l'arme
                                    </p>
                                </Row>

                                {dataDeroule.personnes.filter(Boolean).map((personne) =>
                                    arme.statutCourant === STATUT_TRANSFERT &&
                                    personne.libelleRelation === LOCALISATION_ORIGINE ? (
                                        <Row className={styles.sectionTitle}>
                                            <div className={styles.elementTitle}>
                                                {displayStatut(LIBELLE_EXPEDITION_EN_COURS)}
                                            </div>
                                        </Row>
                                    ) : (
                                        <SectionPresentationArme
                                            key={personne.uuid}
                                            titre={personne.libelleRelation}
                                            donnees={[
                                                ['Intitulé', personne.libellePersonne],
                                                ['Numéro SIA', personne.numeroSia],
                                                ['Catégorie', personne.categorieLibelle],
                                                [
                                                    'Adresse',
                                                    `${personne.adresse?.numeroDeVoie ?? ''} ${
                                                        personne.adresse?.libelleVoie ?? ''
                                                    }`.trim() || '',
                                                ],
                                            ]}
                                        />
                                    ),
                                )}
                            </div>
                        </>
                    )}
                </SegmentLoader>
            </ModalV2Content>
            <ModalV2Footer>
                <ButtonGroup align="right" inline>
                    <TemplateBoutonsActions
                        ouvrirModaleValiderAcquisition={ouvrirModaleValiderAcquisition}
                        ouvrirModalePerteVol={ouvrirModalePerteVol}
                        fermerModale={fermerModale}
                        armesSelectionnees={[arme]}
                        rechargerTableau={rechargerTableau}
                        rolesProfil={dataProfil ? dataProfil.roles : []}
                    />
                </ButtonGroup>
            </ModalV2Footer>
        </ModalV2>
    );
};

ModaleInformationArme.propTypes = {
    isLoadingFicheSituation: PropTypes.bool.isRequired,
    getApi: PropTypes.func.isRequired,
    rechargerTableau: PropTypes.func.isRequired,
    arme: PropTypes.arrayOf(
        PropTypes.shape({
            uniquid: PropTypes.string.isRequired,
            numeroEncodage: PropTypes.string.isRequired,
            classement: PropTypes.string.isRequired,
            regimeDetention: PropTypes.string.isRequired,
            modele: PropTypes.string.isRequired,
            marque: PropTypes.string.isRequired,
            type: PropTypes.string.isRequired,
            statut: PropTypes.string.isRequired,
            calibreCanon: PropTypes.string.isRequired,
        }).isRequired,
    ),
    data: PropTypes.shape({
        ficheSituation: PropTypes.shape({
            action: PropTypes.func,
            titreFichier: PropTypes.string,
            mimeType: PropTypes.string,
            isLoading: PropTypes.bool,
        }),
    }),
    dataProfil: PropTypes.shape({
        roles: PropTypes.array.isRequired,
    }),
    fermerModale: PropTypes.func.isRequired,
    ouvrirModalePerteVol: PropTypes.func.isRequired,
    dataFicheSituation: PropTypes.string,
    ouvrirModaleValiderAcquisition: PropTypes.func.isRequired,
};

export default connect(
    (state) => {
        const { data: dataProfil } = state.profil.usager;
        const { isLoading: isLoadingFicheSituation, data: dataFicheSituation } =
            state.armes.ficheSituationArme;
        const { isLoading, data } = state.recherche.armes;
        return {
            isLoadingFicheSituation,
            dataProfil,
            dataFicheSituation,
            isLoading,
            data,
        };
    },
    {
        getApi: getAPI,
    },
)(ModaleInformationArme);
